export default __webpack_public_path__ + "static/media/gallery04.bcce65b2.jpg";